import { graphql, useStaticQuery } from "gatsby";

const useMainGlobalQuery = () => {
  const query = useStaticQuery(graphql`
    {
      allWp {
        nodes {
          mainGlobal {
            acfMainGlobal {
              mainWhyList {
                icon {
                  sourceUrl
                }
                content {
                  title
                  description
                }
              }
              mainOpinionsList {
                logo {
                  sourceUrl
                }
                content {
                  average
                  amount
                  location
                  link
                }
              }
              mainGalleryImages {
                sourceUrl
              }
            }
          }
        }
      }
    }
  `);

  return query.allWp.nodes[0].mainGlobal.acfMainGlobal;
};

export default useMainGlobalQuery;
